import { X } from "lucide-react";

type ReportReasonModalProps = {
	open: boolean;
	title?: string;
	description?: string;
	reason: string;
	error?: string;
	loading?: boolean;
	onReasonChange: (value: string) => void;
	onClose: () => void;
	onSubmit: () => void;
};

export function ReportReasonModal({
	open,
	title = "Reportar un problema",
	description = "Describe brevemente el motivo del reporte para enviar el pedido a soporte.",
	reason,
	error,
	loading = false,
	onReasonChange,
	onClose,
	onSubmit,
}: ReportReasonModalProps) {
	if (!open) return null;

	return (
		<div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-6'>
			<div className='relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-white p-5 sm:p-6 shadow-2xl'>
				<button
					type='button'
					aria-label='Cerrar'
					onClick={onClose}
					disabled={loading}
					className='absolute right-4 top-4 rounded-full p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 disabled:cursor-not-allowed'
				>
					<X className='h-5 w-5' />
				</button>

				<h2 className='mb-1 text-lg font-semibold text-gray-800'>{title}</h2>
				<p className='mb-4 text-sm text-gray-500'>{description}</p>

				<label
					htmlFor='report-reason'
					className='mb-1 block text-sm font-medium text-gray-700'
				>
					Motivo del reporte
				</label>
				<textarea
					id='report-reason'
					value={reason}
					onChange={(event) => onReasonChange(event.target.value)}
					placeholder='Ej: El proveedor no se presentó en la fecha acordada.'
					rows={4}
					className='w-full resize-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-primary focus:ring-1 focus:ring-primary'
				/>
				{error ? <p className='mt-2 text-xs text-red-600'>{error}</p> : null}

				<div className='mt-5 flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2'>
					<button
						type='button'
						onClick={onClose}
						disabled={loading}
						className='rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed'
					>
						Cancelar
					</button>
					<button
						type='button'
						onClick={onSubmit}
						disabled={loading}
						className='rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-70'
					>
						{loading ? "Enviando..." : "Enviar reporte"}
					</button>
				</div>
			</div>
		</div>
	);
}
